import { createAction } from 'redux-actions';
import { createRoutine } from 'redux-saga-routines';
import {
  NETWORK_PERFORMANCE_DOWNLOAD_REPORT,
  NETWORK_PERFORMANCE_GET_DASHBOARD,
  NETWORK_PERFORMANCE_SET_DATE_RANGE,
  NETWORK_PERFORMANCE_SET_GRANULARITY,
  NETWORK_PERFORMANCE_SET_STUDIOS,
} from './types';

export const networkPerformanceSetDateRange = createAction(
  NETWORK_PERFORMANCE_SET_DATE_RANGE
);
export const networkPerformanceSetStudios = createAction(
  NETWORK_PERFORMANCE_SET_STUDIOS
);
export const networkPerformanceSetGranularity = createAction(
  NETWORK_PERFORMANCE_SET_GRANULARITY
);
export const networkPerformanceGetDashboard = createRoutine(
  NETWORK_PERFORMANCE_GET_DASHBOARD
);
export const networkPerformanceDownloadReport = createRoutine(
  NETWORK_PERFORMANCE_DOWNLOAD_REPORT
);
